import { render, staticRenderFns } from "./copyVertical.vue?vue&type=template&id=2674dab8&"
import script from "./copyVertical.vue?vue&type=script&lang=ts&"
export * from "./copyVertical.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports